import { FileInterface } from "../../../types/RecordInterfaces";
import React, { useRef } from "react";
import { Button, Col, Row } from "reactstrap";
import { Popover, Whisper } from "rsuite";

interface Props {
  item: FileInterface;
  index: number;
  isFirst: boolean;
  setOptionsOpen: (open: boolean) => void;
  FileOptions: React.ComponentType<any>;
  openPreview: boolean;
  toggleOpenPreview: () => void;
}

/**
 * FileWithOptions - File option for SingleFileRecord component
 * @param {object} item - The file object
 * @param {number} index - The index of the file in the list
 * @param {boolean} isFirst - Whether or not
 * @param {function} setOptionsOpen - Function to open/close the FileOptions
 * @param {component} FileOptions - FileOptions component containing the file options
 * @param {boolean} openPreview - Whether or not the preview is open
 */
const FileWithOptions = ({
  item,
  index,
  isFirst,
  setOptionsOpen = () => {},
  FileOptions,
  openPreview,
  toggleOpenPreview,
}: Props) => {
  const fileRef = useRef<any>(null);

  return (
    <div
      className={`p-2 ${!isFirst && "border-bottom border-superlight"}`}
      key={index}
    >
      <Row className="align-items-center cursor-pointer">
        <Col
          xs=""
          className="pr-0 text-truncate"
          style={{ width: "calc(100% - 128px)" }}
        >
          <h5
            onClick={toggleOpenPreview}
            className="m-0 font-weight-500 text-truncate d-inline pl-2 text-primary text-primary-dark--hover text-underline--hover"
            style={{
              lineHeight: 1,
              position: "relative",
              top: -2,
            }}
          >
            {item.Name}
          </h5>
        </Col>
        <Col xs="auto">
          <Whisper
            placement="autoVerticalEnd"
            trigger="click"
            onClose={() => setOptionsOpen(false)}
            ref={fileRef}
            speaker={
              <Popover
                className={`${openPreview ? "d-none" : ""} sidebar-popover p-0`}
                full
              >
                <FileOptions value={item} index={index} fileRef={fileRef} />
              </Popover>
            }
            controlId="newRecordDropdown"
          >
            <Button
              size="sm"
              outline
              className="btn-icon-only"
              style={{
                height: "1.5rem",
                width: "1.5rem",
              }}
              onClick={() => setOptionsOpen(true)}
            >
              <i
                className={`mdi mdi-dots-horizontal`}
                style={{
                  fontSize: 20,
                  lineHeight: 1,
                  position: "relative",
                  top: 1,
                }}
              ></i>
            </Button>
          </Whisper>
        </Col>
      </Row>
    </div>
  );
};

export default FileWithOptions;
